export interface GetUserReserveCollectionsRequest {
  id: string
}

export function GetUserReserveCollectionsRequestToJSON(
  value: GetUserReserveCollectionsRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
